// Identidade visual do sistema TrenzoX (painel web, apps mobile e esta
// landing page) -- fundo quase preto neutro, laranja único de acento,
// Plus Jakarta Sans. 2026-09-07: revertido de volta a essa identidade
// depois de uma leva anterior que tinha adotado à risca a paleta de um
// design de referência (near-black quente + Poppins/Nunito); a
// ESTRUTURA de seção dessa referência foi mantida, só a cor/tipografia
// voltou a ser a do sistema.
export const colors = {
  background: '#121212',
  surface: '#1E1E1E',
  surfaceAlt: '#181818',
  surfaceSunken: '#161616',
  surfaceAccent: '#241a14',
  surfaceHighlight: '#2a1d15',

  border: '#2A2A2A',
  borderSubtle: '#232323',
  borderAccent: '#3A2A21',
  borderHighlight: '#4a3323',

  primary: '#FF8C55',
  primaryHover: '#FFA878',
  onPrimary: '#121212',

  textPrimary: '#FFFFFF',
  textSecondary: '#D1D5DB',
  textMuted: '#9CA3AF',
  textFaint: '#6B7280',
  textFainter: '#5B6472',
  textFaintest: '#4B5563',
  textDisabled: '#3F4451',
  textOff: '#4B5563',

  danger: '#E58A8A',
  dangerBg: '#221818',

  warning: '#F2C14E',
};

export const typography = {
  fontFamily: "'Plus Jakarta Sans', Helvetica, sans-serif",
  displayFontFamily: "'Plus Jakarta Sans', Helvetica, sans-serif",
  monoFontFamily: "'JetBrains Mono', monospace",
};
